import React, { useState } from "react";

const Faq = ({ question, answer, index }) => {
  const [open, setOpen] = useState(index === 0 ? true : false);
  return (
    <div
      className={`flex items-center justify-center`}
      onClick={() => {
        if (!open) {
          setOpen(!open);
        }
      }}
    >
      <div
        style={{ background: open ? "var(--gradient-primary)" : "" }}
        className={`flex max-w-[800px] w-full justify-between items-center gap-16px py-25px px-30px rounded-xl border border-accent-50 dark:border-none dark:bg-accent-800 shadow-lg cursor-pointer ${
          open ? "text-primary-50" : ""
        }`}
      >
        <div className="flex flex-col gap-16px">
          <div className="text-lg font-medium dark:text-primary-300">
            {question}
          </div>
          <div className={`max-w-[740px] ${open ? "" : "hidden"}`}>
            {answer}
          </div>
        </div>
        <button
          style={{ background: open ? "white" : "var(--gradient-primary)" }}
          className={`outline-none border-none py-2 px-10px aspect-square rounded-full cursor-pointer opacity-90 duration-300 ${
            open ? "bg-white rotate-45" : ""
          }`}
          onClick={() => {
            setOpen(!open);
          }}
        >
          {open ? (
            <svg
              width="9"
              height="8"
              viewBox="0 0 9 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.896 5.224V3.512H3.904V0.743999H5.648V3.512H8.64V5.224H5.648V7.992H3.904V5.224H0.896Z"
                fill="#766AFF"
              />
            </svg>
          ) : (
            <svg
              width="9"
              height="8"
              viewBox="0 0 9 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.896 5.224V3.512H3.904V0.743999H5.648V3.512H8.64V5.224H5.648V7.992H3.904V5.224H0.896Z"
                fill="white"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default Faq;
